import {
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { BaseProps } from "src/components/move-inRegistrationTabs/interfaces";
import NocsRequests from "../../stores/NocsRequestsStore";
import General from "../../stores/GeneralStore";
import MoveInOut, { RegistrationData } from "../../stores/MoveInOutStore";

import { useFormik } from "formik";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Label } from "../complaint/Complaint.styled";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { NotifyError } from "../../utils/ShowError";
import CloseIcon from "../../assets/CloseIcon.svg";
import ButtonPrimary from "../../components/button.primary/button.primary.component";

import { toJS } from "mobx";
import isEmpty from "../../../src/utils/objectNull";
import validateEID from "../../utils/validateEID";

interface Obj {
  [key: string]: string;
}

interface Props {
  onValidateClick: (id: string, type: string, bType: string) => Promise<void>;
  validateLoader: Boolean;
  setValidateLoader: any;
  onClose: any;
}

const TypeModal = ({
  onValidateClick,
  validateLoader,
  setValidateLoader,
  onClose,
}: Props) => {
  const [type, setType] = useState<any>("Individual");
  const [bType, setBType] = useState<string>("");
  const [idSet, setIdSet] = useState<any>("");
  const idValue = useRef<HTMLInputElement | null>(null);

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event?.target?.value as string);
    formik.setFieldValue("emirateId", "");
    setIdSet("");

  };

  const businessTypeChange = (event: SelectChangeEvent) => {
    setBType(event?.target?.value as string);
    formik.setFieldValue("emirateId", "");
    setIdSet("");
  };

  const isOnGracePeriod =async (endDate: any) => {
    try{
      const today = new Date();
      const expiryDate = new Date(endDate);
      // const grace3 =await getGracePeriod()
      const grace = await MoveInOut.getMoveInDetails({
        id:idValue.current?.value,
        type: bType ? bType : type === "Individual" ? "I" : "B",
        premiseId: General.premise.premiseId,
      });
      // Calculate the expiry date with the grace period added
      const expiryDatenew = new Date(expiryDate.getTime());
      expiryDatenew.setDate(expiryDate.getDate() + grace);
      console.log("grace__ expiry date",expiryDate)
      // Compare today's date with the modified expiry date
      return today <= expiryDatenew;
    }catch(error){
        setValidateLoader(false);
    }
   
  };
  const getGracePeriod = async () => {
    const res = await General.gracePeriod({ errorId: "gracePeriod" });
    return res?.result?.moveinGracePeriod;
  };
  const handleValidate = async () => {
    try{
      setValidateLoader(true);
      const id = idValue.current?.value;
      if (!id || id == null) {
        setValidateLoader(false)
        return;
      }
      const dataWithError = {
        data: {id,brand:bType=="FZ"?"AFZ":bType},
        errorId: "emirateId",
      };
      if (type == "Business" && bType != "OTHRDED") {
        if (bType == "FZ"||bType=="MFZ") {
          const resp = await General.validateFZ(dataWithError,);
          const isGracePeriod= await isOnGracePeriod(resp.accountDetails.fZ_License_Expiry_Date__c);
          if (
            resp.status === "0" &&
            resp.accountDetails !== null &&
            isGracePeriod
          ) {
            onValidateClick(id, type == "Individual" ? "I" : "B", bType);
            setValidateLoader(false);
          } else {
            // NotifyError(General.codeLabels["cm_nodatafound"]?.label);
            setValidateLoader(false);
          }
        } else {
          var data = {};
          if(bType=="TDLIC"){
              data={ licenseNumber: id }
          }else{
           data= { applicationNo: id }
          }
         
          const resp = await General?.validateAjmanLc({
            data,
            errorId: "emirateId",
          });
          if (
            resp.getTransactionInfoResponse &&
            resp.getTransactionInfoResponse.getTransactionInfoResult.newDataSet.transactionStatus
          ) {
            if (
            await  isOnGracePeriod(
                resp.getTransactionInfoResponse.getTransactionInfoResult
                  .newDataSet.transactionStatus.endDate
              )
            ) {
              onValidateClick(id, type == "Individual" ? "I" : "B", bType);
              setValidateLoader(false);
            } else {
              // NotifyError(General?.codeLabels["cm_nodatafound"]?.label);
              setValidateLoader(false);
            }
          } else {
            NotifyError(General?.codeLabels["cm_nodatafound"]?.label);
            setValidateLoader(false);
          }
        }
      } else {
        if (type === "Individual" && id.length != 15) return;
  
        onValidateClick(id, type === "Individual" ? "I" : "B", bType);
      }
    }catch(error){
      setValidateLoader(false)
      NotifyError(General?.codeLabels['cm_nodatafound']?.label)
    }
  
  };

  const validationSchema = Yup.object().shape({
    emirateId:
      type == "Individual"
        ? Yup.string()
            .required(General?.codeLabels["cm_nocpersonidnovalidation"]?.label)
            .min(15, General?.codeLabels["cm_min_15dgts"]?.label)
            .max(15, General?.codeLabels["cm_mob_eidmax"]?.label)
            .matches(/^784[0-9]{12}$/, General?.codeLabels["cm_emirate_req"]?.label?General?.codeLabels["cm_emirate_req"]?.label:"Emirates ID not valid")
        : Yup.string().required(General?.codeLabels["cm_requirederr"]?.label).max(15, General?.codeLabels["cm_mob_tdlicmax"]?.label).min(1, General?.codeLabels["cm_mob_tdlicmin"]?.label),
  });
  const formik = useFormik({
    initialValues: {
      emirateId: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 2));
    },
  });
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  useEffect(() => {
    if (idValue.current) {
      idValue.current.value = ""; // Reset the field when `type` changes
    }
  }, [type,bType]);
  return (
    <div
      style={{
        width: General?.isLargeScreen ? "60%" : "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor:General.contrast.contrastColor
        ? General.contrast.contrastBackground
        : '#fff',
        margin: "10% auto",
        direction:
          General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA"
            ? "rtl"
            : "ltr",
            
        
      }}
    >
      <div
        style={{
          // height: '20%',
          width: "100%",
          justifyContent: "space-between",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          background: General.contrast.contrastBackground
          ? General.contrast.contrastColor
          : General?.ColorAss,
          display: "flex",
          alignItems: "center",
        }}
        //className={General?.colorClass}
      >
        <h1
          style={{
            color:General.contrast.contrastColor
            ? General.contrast.contrastBackground
            : '#fff',
            justifySelf: "flex-start",
            fontSize: General?.isLargeScreen ? "" : "2rem",
          }}
        >
          {General?.codeLabels["cm_movein"]?.label !== undefined
            ? General?.codeLabels["cm_movein"]?.label
            : "Move-In"}
        </h1>
        <img src={CloseIcon} alt="" onClick={onClose} />
      </div>
      <Formik
            initialValues={{
              emirateId: idSet,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                // alert(JSON.stringify(values, null, 2));
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => (
              <form onSubmit={formik.handleSubmit}>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
         backgroundColor:General.contrast.contrastColor
          ? General.contrast.contrastBackground
          : '#fff',
          margin: "auto",
          padding: General?.isLargeScreen ? "2rem" : "0.5rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
            marginTop: "1rem",
            marginBottom: "3rem",
            gap: "1.5rem",
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
            <InputLabel id="type-select-label">
              <span
                style={{ 
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color:General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                }}
              >
                {General?.codeLabels["cm_asreqtypetable"]?.label !== undefined
                  ? General?.codeLabels["cm_asreqtypetable"]?.label
                  : "Type"}
              </span>
            </InputLabel>
            <Select
              labelId="type-select-label"
              id="type-select"
              value={type}
              label="Age"
              onChange={handleTypeChange}
              MenuProps={{
                sx: {
                    '& .MuiMenu-paper': {
                        backgroundColor: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : '#fff',
                        color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss
                    },
                    '& .MuiMenuItem-root:hover': {
                        backgroundColor: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss,
                        color: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : '#fff',
                    },
                    '& .Mui-selected': {
                      backgroundColor: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : '#fff',
                      color: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : General?.ColorAss
                    }
                }
            }}
            sx={{
                color:  General.contrast.contrastColor
                ? General.contrast.contrastColor
                : General?.ColorAss,
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                },
                '.MuiSvgIcon-root': {
                    color: General.contrast.contrastColor
                    ? General.contrast.contrastColor
                    : General?.ColorAss
                },
                '&:before': {
                    borderBottom: `1px solid red`
                },
                '&:hover': {
                    ':before': {
                        borderBottom: `1px solid ${General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : General?.ColorAss}`
                    }
                },
            }}
            >
              <MenuItem value={"Business"}>
                <span
                  style={{ fontSize: `${General.accessibility.fontSize}rem` }}
                >
                  {General?.codeLabels["cm_bussiness"]?.label !== undefined
                    ? General?.codeLabels["cm_bussiness"]?.label
                    : "Business"}
                </span>
              </MenuItem>
              <MenuItem value={"Individual"}>
                <span
                  style={{ fontSize: `${General.accessibility.fontSize}rem` }}
                >
                  {General?.codeLabels["cm_individual"]?.label !== undefined
                    ? General?.codeLabels["cm_individual"]?.label
                    : "Individual"}
                </span>
              </MenuItem>
            </Select>
            <div style={{ height: "1rem" }}></div>
          </div>

          {type == "Individual" ? null : (
            <div
              style={{ display: "flex", flexDirection: "column", flex: "50%" }}
            >
              <InputLabel 
              id="business-select-label"
              style={{ 
                fontSize: `${General.accessibility.fontSize}rem`,
                color:General.contrast.contrastColor
                ? General.contrast.contrastColor
                : General?.ColorAss,
              }}
              >
                {General?.codeLabels["cm_mvin_label_business_type"]?.label !==
                undefined
                  ? General?.codeLabels["cm_mvin_label_business_type"]?.label
                  : "Business Type"}
              </InputLabel>
              <Select
                labelId="business-select-label"
                id="business-select"
                label="Business Type"
                onChange={businessTypeChange}
                style={{ width: General?.isLargeScreen ? "" : "75vw" }}
                MenuProps={{
                  sx: {
                      '& .MuiMenu-paper': {
                          backgroundColor: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : '#fff',
                          color: General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : General?.ColorAss
                      },
                      '& .MuiMenuItem-root:hover': {
                          backgroundColor: General.contrast.contrastBackground
                          ? General.contrast.contrastBackground
                          : General?.ColorAss,
                          color: General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : '#fff',
                      },
                      '& .Mui-selected': {
                        backgroundColor: General.contrast.contrastColor
                        ? General.contrast.contrastColor
                        : '#fff',
                        color: General.contrast.contrastBackground
                        ? General.contrast.contrastBackground
                        : General?.ColorAss
                      }
                  }
              }}
              sx={{
                  color:  General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                  
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                  },
                  '.MuiSvgIcon-root': {
                      color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss
                  },
                  '&:before': {
                      borderBottom: `1px solid ${General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss}`
                  },
                  '&:hover': {
                      ':before': {
                          borderBottom: `1px solid ${General.contrast.contrastColor
                          ? General.contrast.contrastColor
                          : General?.ColorAss}`
                      }
                  },
              }}
              >
                <MenuItem
                  style={{ fontSize: `${General.accessibility.fontSize}rem` }}
                  value={"TDLIC"}
                >
                  {General?.codeLabels["cm_mvin_bt_tdlic"]?.label !== undefined
                    ? General?.codeLabels["cm_mvin_bt_tdlic"]?.label
                    : "Ajman Trade License Number"}
                </MenuItem>
                <MenuItem
                  style={{ fontSize: `${General.accessibility.fontSize}rem` }}
                  value={"MFZ"}
                >
                  {General?.codeLabels["cm_mvin_bt_mfztdlic"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_mvin_bt_mfztdlic"]?.label
                    : "Ajman Media City Freezone Trade License Number"}
                </MenuItem>
                <MenuItem
                  style={{ fontSize: `${General.accessibility.fontSize}rem` }}
                  value={"TDLIC-AN"}
                >
                  {General?.codeLabels["cm_mvin_bt_dedappno"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_mvin_bt_dedappno"]?.label
                    : "Ajman Trade License-Application Number"}
                </MenuItem>
                <MenuItem
                  style={{ fontSize: `${General.accessibility.fontSize}rem` }}
                  value={"FZ"}
                >
                  {General?.codeLabels["cm_mvin_bt_fztdlic"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_mvin_bt_fztdlic"]?.label
                    : "Ajman Freezone Trade License Number"}
                </MenuItem>
                <MenuItem
                  style={{ fontSize: `${General.accessibility.fontSize}rem` }}
                  value={"OTHRDED"}
                >
                  {General?.codeLabels["cm_mvin_bt_othrded"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_mvin_bt_othrded"]?.label
                    : "Other Emirates Trade License Number"}
                </MenuItem>
              </Select>
              <div style={{ height: "1rem" }}></div>
            </div>
          )}
         
                <Label
                  style={{
                    fontSize: `${General.accessibility.fontSize}rem`,
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "rgba(0, 0, 0, 0.6)",
                    lineHeight: "16px",
                    gap: "0.2rem",
                    fontStyle: "normal",
                    width: "100%",
                    fontWeight: "100",
                  }}
                >
                  {type == "Individual"
                    ? General?.codeLabels["cm_uni"]?.label
                    : General?.codeLabels["cm_tdlic"]?.label}
                  *
                  <Field
                    style={{
                      height: "56px",
                      padding: "15px",
                      flex: "50%",
                      background: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : '#fff',
                      width: General?.isLargeScreen ? "20rem" : "75vw",
                      color:General.contrast.contrastColor
                      ? General.contrast.contrastBackground
                      : General?.ColorAss,
                    }}
                    className="custom-placeholder"
                    type="number"
                    placeholder={
                      type == "Individual" ? General?.codeLabels['cm_emirate_id']?.label : General?.codeLabels['cm_tdlic']?.label
                    }
                    name="emirateId"
                    innerRef={idValue}
                    value={idSet}
                    onChange={(e:any) => {
                      setIdSet(e.target.value);
                      values.emirateId = e.target.value;
                      formik.setFieldValue("emirateId", e.target.value);
                    
                     }

                    }
                  />
                  <div style={{ height: "0.5rem" }}>
                    <ErrorMessage
                      name="emirateId"
                      component="div"
                      className="error-message"
                    />
                  </div>
                </Label>
          
        </div>

        <ButtonPrimary
          label={""}
          styles={{
            background: contrast?.contrastColor
              ? contrast?.contrastColor
              : ColorAss || "#101E8E",
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "white",
            alignSelf: "flex-end",
            width: General?.isLargeScreen ? "12rem" : "100%",
            height: "50px",
            justifyContent: "center",
            fontSize: `${General.accessibility.fontSize}rem`,
            zIndex: 0,
            opacity:isEmpty(errors)?"1":"0.5"
          }}
          onClick={() => {
            if (type == "Individual") {
              if(validateEID(idValue?.current?.value))
              if (isEmpty(errors)) handleValidate();
            } else {
              if (isEmpty(errors)) handleValidate();
            }
          }}
        >
          {validateLoader ? (
            <Spinner width="30px" height="30px" />
          ) : General?.codeLabels["cm_validate"]?.label !== undefined ? (
            General?.codeLabels["cm_validate"]?.label
          ) : (
            "VALIDATE"
          )}
        </ButtonPrimary>
      </div>
      </form>
      )}
    </Formik>
    </div>
  );
};

export default TypeModal;
